import create from 'zustand';
import { profileModel } from '../Axios/AxiosConfig'; // Adjust the path according to your structure
import { getUserDetails } from '../Auth/AuthUtil';
import Profile from '../Profile/Profile';

const WellnessStore = create((set, get) => ({
    isDietLoading: true,
    isMeditationdataLoading: true,
    isRecipeLoading: true,
    isYogaLoading: true,
    isPranayamaLoading: true,
    Profile: null,
    Selected_Wellness: [],
    Meditationdata: [],
    Diets: [],

    Recipes: [],

    RecipeItem: null,

    selectedYogas: [],

    unselectedYogas: [],

    selectedPranayama: [],

    unselectedPranayama: [],

    isWeeklyRecommendationLoading: true,

    WeeklyRecommendation: [],

    Articles: [],

    isArticlesLoading: false,


    getWeeklyRecommendation: async () => {
        try {
            const userDetails = getUserDetails();
            if (userDetails && userDetails.UID) {
                const res = await profileModel.get(`/getWeeklyActivitiesRecommendation/${userDetails?.UID}`)

                if (res.status === 200) {
                    console.log(res?.data)
                    set({
                        WeeklyRecommendation: res?.data?.Activity,
                        isWeeklyRecommendationLoading: false
                    })
                }
            }
            else {
                set({
                    isWeeklyRecommendationLoading: false
                });
                console.log('User details not found');
            }
        }

        catch (err) {
            set({
                isWeeklyRecommendationLoading: false
            });

            console.log(err?.response?.data);
        }
    },

    updateActivitylineItem: async (timing, lineItemIndex, status) => {
        try {
            const userDetails = getUserDetails();
            if (!userDetails || !userDetails.UID) {
                console.log("User details not found");
                return;
            }

            set((state) => {
                const updatedRecommendations = state.WeeklyRecommendation.map((activity) => {
                    if (activity.timing === timing) {
                        return {
                            ...activity,
                            lineItems: activity.lineItems.map((item, index) =>
                                index === lineItemIndex ? { ...item, completed: status } : item
                            ),
                        };
                    }
                    return activity;
                });

                return { WeeklyRecommendation: updatedRecommendations };
            });

            let res = await profileModel.put('/update-activity', {
                UID: userDetails.UID,
                timing,
                lineItemIndex,
                status
            });

            if (res.status !== 200) {
                get().getWeeklyRecommendation();
            }
        } catch (err) {
            console.log(err?.response?.data);
            get().getWeeklyRecommendation();
        }
    },

    getProfile: async () => {
        try {
            const userDetails = getUserDetails();
            if (userDetails && userDetails.UID) {
                let res = await profileModel.get(`/Profile/${userDetails?.UID}`)
                if (res.status === 200) {
                    const profile = res?.data
                    set({ Profile: profile })
                }
            }
        }
        catch (err) {
            console.log(err?.response?.data)
        }
    },

    getDiet: async () => {
        try {
            const userDetails = getUserDetails();
            if (userDetails && userDetails.UID) {
                const res = await profileModel.post('/getDietRecommendations', {
                    id: userDetails.UID
                });
                if (res.status === 200) {
                    set({
                        Diets: res?.data,
                        isDietLoading: false
                    });
                }
            } else {
                set({
                    isDietLoading: false
                });
                console.error('User details not found');
            }

        } catch (err) {
            set({
                isDietLoading: false
            });
            console.error(err.response?.data || err.message);
        }
    },

    getOneRecipe: async (id) => {
        try {
            const userDetails = getUserDetails();
            if (userDetails && userDetails.UID) {
                const res = await profileModel.get(`/getRecipeById/${id}`, {
                    id: userDetails.UID
                });
                if (res.status === 200) {
                    set({
                        RecipeItem: res?.data,
                        isRecipeItemLoading: false
                    });
                }
            } else {

                set({
                    isRecipeLoading: false
                });

                console.error('User details not found');
            }

        } catch (err) {

            set({
                isRecipeLoading: false
            });

            console.error(err.response?.data || err.message);
        }
    },

    getRecipes: async () => {
        try {
            const userDetails = getUserDetails();
            if (userDetails && userDetails.UID) {
                const res = await profileModel.post('/getRecipiesRecommendations', {
                    id: userDetails.UID
                });
                if (res.status === 200) {
                    set({
                        Recipes: res?.data,
                        isRecipeLoading: false
                    });
                }
            } else {

                set({
                    isRecipeLoading: false
                });

                console.error('User details not found');
            }

        } catch (err) {

            set({
                isRecipeLoading: false
            });

            console.error(err.response?.data || err.message);
        }
    },

    getYoga: async () => {
        try {
            const userDetails = getUserDetails();
            if (userDetails && userDetails.UID) {
                const res = await profileModel.get(`/getYoga/${userDetails?.UID}`);
                if (res.status === 200) {
                    set({
                        selectedYogas: res?.data?.selectedPoses,
                        unselectedYogas: res?.data?.unselectedPoses,
                        isYogaLoading: false
                    });
                }
            } else {
                console.error('User details not found');
            }

        } catch (err) {
            console.error(err.response?.data || err.message);
        }
    },

    getPranayama: async () => {
        try {
            const userDetails = getUserDetails();
            if (userDetails && userDetails.UID) {
                const res = await profileModel.get(`/getPranayama/${userDetails.UID}`);
                if (res.status === 200) {
                    set({
                        selectedPranayama: res?.data?.selectedPranayama,
                        unselectedPranayama: res?.data?.unselectedPranayama,
                        isPranayamaLoading: false
                    });
                }
            } else {
                console.error('User details not found');
            }

        } catch (err) {
            console.error(err.response?.data || err.message);
        }
    },

    getMedidationData: async () => {
        try {
            const res = await profileModel.get('/getMeditation');
            if (res.status === 200) {
                set({
                    Meditationdata: res?.data,
                    isMeditationdataLoading: false
                });
            }
        } catch (err) {
            console.error(err?.response?.data || err?.message);
        }
    },

    getSelected_Wellness: async () => {
        try {
            const userDetails = getUserDetails();
            if (userDetails && userDetails.UID) {
                const res = await profileModel.get(`getwellnessCategories/${userDetails?.UID}`);
                if (res.status === 200) {
                    set({ Selected_Wellness: res?.data?.[0]?.Categories });
                }
            } else {
                console.log('User details not found');
            }
        } catch (err) {
            console.log(err?.response?.data || err?.message);
        }
    },

    getArticles: async () => {
        try {
            let res = await profileModel.get('/getarticles')
            if (res.status === 200) {
                set({
                    Articles: res.data,
                    isArticlesLoading: false
                })
            }
        }
        catch (err) {

            set({
                Articles: [],
                isArticlesLoading: false
            })

            console.log(err?.response?.data || err?.message);
        }
    }

}));

export default WellnessStore;
